const POLYGON_OUTLINE = 'POLYGON_OUTLINE';
const SOLID_LINE = 'SOLID_LINE';
const DASHED_LINE = 'DASHED_LINE';
const RASTER_SOURCE = 'RASTER_SOURCE';
const LABEL_LAYER = 'LABEL_LAYER';
const HIGHLIGHT_LAYER = 'HIGHLIGHT_LAYER';
const HIGHLIGHT_FILL_LAYER = 'HIGHLIGHT_FILL_LAYER';
const CIRCLE_LAYER = 'CIRCLE_LAYER';

// set marker on vetro layer to indicate what kind of mapbox layer it should be

export const toPolygonOutline = (layer) =>
  layer.HIGHLIGHT_FILL_LAYER ? layer : { ...layer, [POLYGON_OUTLINE]: true };

export const toPolygonHighlightFill = (layer) => ({ ...layer, [HIGHLIGHT_FILL_LAYER]: true });

export const toSolidLine = (layer) => ({ ...layer, [SOLID_LINE]: true });

export const toRasterSource = (layer) => ({ ...layer, [RASTER_SOURCE]: true });

export const toLabelLayer = (layer) => ({ ...layer, [LABEL_LAYER]: true });

export const toHighlightLayer = (layer) => ({ ...layer, [HIGHLIGHT_LAYER]: true });

export const toDashedLine = (layer) => ({ ...layer, [DASHED_LINE]: true });

export const toCircleLayer = (layer) => ({ ...layer, [CIRCLE_LAYER]: true });

// determine if a vetro layer corresponds to a type of mapbox layer

export const isRasterMapboxLayer = (vetroLayer) => vetroLayer[RASTER_SOURCE];

export const isLabelMapboxLayer = (vetroLayer) => vetroLayer[LABEL_LAYER];

export const isHighlightMapboxLayer = (vetroLayer) => vetroLayer[HIGHLIGHT_LAYER];

export const isPolygonOutlineMapboxLayer = (vetroLayer) => vetroLayer[POLYGON_OUTLINE];

export const isDashedLineLayer = (vetroLayer) => vetroLayer[DASHED_LINE];

export const isSolidLineLayer = (vetroLayer) => vetroLayer[SOLID_LINE];

export const isCircleLayer = (vetroLayer) => vetroLayer[CIRCLE_LAYER];

export const isPolygonHighlightFillLayer = (vetroLayer) => vetroLayer[HIGHLIGHT_FILL_LAYER];
